// TODO: move Standard colors into @b-stock/fe-core design system and remove this file
const Standard = {
  Green: '#008000',
  Red: '#C70000',
  LightGreen: '#EFF5DC',
  Orange: '#FF9900',
  WonGreen: '#2D800054',
} as const

export { Standard }
